const IconSearchSvg = (props: any) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00002 8.37671C2.00002 5.06771 4.69102 2.37671 8.00002 2.37671C11.309 2.37671 14 5.06771 14 8.37671C14 11.6857 11.309 14.3767 8.00002 14.3767C4.69102 14.3767 2.00002 11.6857 2.00002 8.37671ZM17.707 16.6697L14.312 13.2737C15.365 11.9197 16 10.2227 16 8.37671C16 3.96571 12.411 0.376709 8 0.376709C3.589 0.376709 0 3.96571 0 8.37671C0 12.7877 3.589 16.3767 8 16.3767C9.846 16.3767 11.543 15.7417 12.897 14.6887L16.293 18.0837C16.488 18.2787 16.744 18.3767 17 18.3767C17.256 18.3767 17.512 18.2787 17.707 18.0837C18.098 17.6927 18.098 17.0607 17.707 16.6697Z"
        fill="white"
      />
    </svg>
  )
}

export default IconSearchSvg
